import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UserState} from "../../api/models/user-state";
import {
  PowerBISettings, PreFilter, US_PreFilter,
  ReportStandardLayout,
  ReportSource,
  ReportStandardType,
  US_ReportStandardLayout,
  US_ReportEmbededExport,
  ReportEmbeddedType, EmbedReportDetails
} from '../../api/models';
import {PowerBIService} from "../../api/services/power-bi.service";
import {
  service as PbiService,
  Report as PbiReport,
  IEmbedConfiguration as PbiEmbedConfig,
  factories as PbiFactories,
  models as PbiModels
} from "powerbi-client"
import { LayoutType as PbiLayoutType } from "powerbi-models"
import {GlobalApp} from "../../tools/global";
import {AdminInteractiveService, PreFilterService, ReportExportService} from '../../api/services';
import { ReportStandardLayoutPropsDialogComponent, ReportStandardLayoutPropsDialogData } from '../../dialogs/report-standard-layout-props-dialog/report-standard-layout-props-dialog.component';
import { DialogResultType } from '../../dialogs/DialogResult';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { ReportEmbeddedExportPropsDialogComponent, ReportEmbeddedExportPropsDialogData } from '../../dialogs/report-embedded-export-props-dialog/report-embedded-export-props-dialog.component';
import { A } from '@angular/cdk/keycodes';
import {DeviceDetectorService} from 'ngx-device-detector';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PrintOnDemandDialogComponent} from '../../dialogs/print-on-demand-dialog/print-on-demand-dialog.component';
import {PodStatusSnackbarComponent, PrintOnDemandData} from '../pod-status-snackbar/pod-status-snackbar.component';
import {Observable, Subscription, timer} from "rxjs";

@Component({
  selector: 'app-powerbi-report-embed',
  templateUrl: './powerbi-report-embed.component.html',
  styleUrls: ['./powerbi-report-embed.component.css']
})
export class PowerbiReportEmbedComponent implements OnInit, OnDestroy {

  private forceNextPageGuardTime: number = 300000;
  private currentTimeoutTime: number = 30000;
  private pagingTimeoutTime: number = 15000;

  public standardType: boolean = false;
  public embedType: boolean = false;

  public reportStandardLayout: US_ReportStandardLayout | undefined = undefined;
  public reportEmbeddedExport: US_ReportEmbededExport | undefined = undefined;

  public preFilters: PreFilter[] = [];
  public reportSource: ReportSource | undefined = undefined;

  public reportStandardType: ReportStandardType | undefined = undefined;
  public reportEmbeddedType: ReportEmbeddedType | undefined = undefined;

  @Output() closeClicked = new EventEmitter();
  @Output() saveClicked = new EventEmitter();
  @Output() pageLoadComplete = new EventEmitter();

  @Input() allowPrintNow = false;

  @ViewChild("pbiContainer") pbiContainer: ElementRef;

  public firstLoad: boolean = true;

  public initialLoad: boolean = false;

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    preFilters: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false,
    hasAiChats: false,
    isValidState: false
  };

  private powerBiClientService: PbiService.Service;
  private embeddedReport: PbiReport = null;
  private currentConfig: PbiEmbedConfig = null;

  public showButtons: boolean = false;

  headerImageSrc: string | undefined = undefined;
  footerImageSrc: string | undefined = undefined;

  headerFile: File | undefined = undefined;
  footerFile: File | undefined = undefined;
  clearHeader: boolean = false;
  clearFooter: boolean = false;

  public preFilterValues: any[];

  public allPages: any[];

  private currentPage: string = '';

  private activeReportPages: string[] = [];

  public loadingReport: boolean = true;

  public lastRendered: Date = new Date();
  public lastReportPage: string = '';

  public currentTimeout: NodeJS.Timeout | undefined;
  public pagingTimeout: NodeJS.Timeout | undefined;
  public overallTimeout: NodeJS.Timeout | undefined;

  public embedDetails?: EmbedReportDetails;

  /*public exportStatus = '';
  public exportState = -1;
  public exportId = '';
  public exportUrl = '';
  public exportTimer: any = null;*/

  constructor(
    protected app: GlobalApp,
    private dialog: MatDialog,
    private powerbiService: PowerBIService,
    private reportExportService: ReportExportService,
    private preFilterService: PreFilterService,
    private deviceService: DeviceDetectorService,
    private adminInteractiveService: AdminInteractiveService,
    private snackBar: MatSnackBar
  ) {
    this.powerBiClientService = new PbiService.Service(
      PbiFactories.hpmFactory,
      PbiFactories.wpmpFactory,
      PbiFactories.routerFactory
    );
  }

  private embedTokenTimer: Observable<number>;
  private embedTokenSubscription: Subscription;

  ngOnInit(): void {
    this.embedTokenTimer = timer(60000, 60000 * 20);
    this.embedTokenSubscription = this.embedTokenTimer.subscribe(t => {
      this.powerbiService.powerBIGetPowerBISettingsForReportStandardType(this.reportStandardType.reportStandardTypeId).subscribe(results => {
        this.embeddedReport.config.embedUrl = results.embedUrl;
        this.embeddedReport.config.accessToken = results.accessToken;
        this.embeddedReport.configChanged(false);
      });
    });
  }

  ngOnDestroy() {
    this.embedTokenSubscription.unsubscribe();
    this.embedTokenTimer = null;
  }

  getFilterPageName() {
    if (this.currentPage && this.currentPage != '') {
      if (this.standardType) {
        if (this.currentPage == this.reportStandardType.filterPage) {
          return "Filter Page (Not Printed)";
        } else {
          return this.currentPage;
        }
      } else if (this.embedType) {
        if (this.currentPage == this.reportEmbeddedType.filterPage) {
          return "Filter Page (Not Displayed)";
        } else {
          return this.currentPage;
        }
      }
    }

    return '';
  }

  getBackgroundColor(): string {
    if (this.reportStandardLayout && this.reportStandardLayout.backgroundColor && this.reportStandardLayout.backgroundColor != '') {
      return "background-color: #" + this.reportStandardLayout.backgroundColor;
    }

    return "";
  }

  loadingStyle(): string {
    var style = "width: calc(100% - 15px); padding-left: 15px; ";
    if (this.loadingReport) {
      style += "visibility: hidden";
    }
    return style;
  }

  hasHeader(): boolean {
    if (this.headerImageSrc && this.headerImageSrc != "")
      return true;

    return false;
  }

  hasFooter(): boolean {
    if (this.footerImageSrc && this.footerImageSrc != "")
      return true;

    return false;
  }

  loadReportPages(reportPagesString: string): string[] {
    if (reportPagesString == null || reportPagesString.length > 0) {
      return reportPagesString.split(",");
    }

    return [];
  }

  getPbiStyleHeight(): string {
    var resp = "height: calc(100% - ";
    var totalCalc = 46;

    if (this.hasHeader()) totalCalc += 100;
    if (this.hasFooter()) totalCalc += 100;

    resp = resp + totalCalc.toString() + "px)";

    return resp;
  }

  public loadReportState(showButtons: boolean, reportStandardLayout: US_ReportStandardLayout, preFilters: PreFilter[], reportSource: ReportSource, reportStandardType: ReportStandardType, initialLoad: boolean, userState?: UserState) {
    this.initialLoad = initialLoad;
    this.standardType = true;
    this.embedType = false;

    this.loadingReport = true;
    this.showButtons = showButtons;
    this.reportStandardLayout = reportStandardLayout;
    this.preFilters = preFilters;
    this.reportSource = reportSource;
    this.reportStandardType = reportStandardType;
    this.userState = userState;
    this.activeReportPages = this.loadReportPages(reportStandardLayout.orderedPages);
    this.allPages = [];
    this.currentPage = '';
    this.headerImageSrc = reportStandardLayout.headerImageUri;
    this.footerImageSrc = reportStandardLayout.footerImageUri;

    this.firstLoad = true;

    if (this.embeddedReport) {
      this.embeddedReport.off("rendered");
      this.embeddedReport.off("visualRendered");
    }

    this.powerbiService.powerBIGetPowerBISettingsForReportStandardType(this.reportStandardType.reportStandardTypeId).subscribe((powerBiSettingsResults) => {
      this.getReportConfig(powerBiSettingsResults).then(currentConfig => {
        this.currentConfig = currentConfig;
        this.embeddedReport = this.powerBiClientService.embed(
          this.pbiContainer.nativeElement,
          this.currentConfig
        ) as PbiReport;

        this.app.pushLoading("Loading Report");

        this.embeddedReport.on("rendered", (event) => {
          if (this.firstLoad) {
            window.setTimeout(() => {
              this.injectFilterData(this.reportStandardLayout.filterData).then((res) => {
                if (this.userState == null) {
                  this.setToInitialPage().then((res2) => {
                    this.app.popLoading();
                    this.loadingReport = false;

                    console.log("Force Next Page Guard Started...");
                    this.overallTimeout = setTimeout(() => {
                      var currentPage = this.activeReportPages.indexOf(this.currentPage);
                      console.log("Forcing Next Page...");
                      console.log('##PAGE##' + (currentPage + 1).toString() + '##' + totalPages.toString());
                      setTimeout(() => {
                        this.moveNextPage();
                      }, 15000);
                    }, this.forceNextPageGuardTime);
                  })
                } else {
                  this.app.popLoading();
                  this.loadingReport = false;
                  if (this.reportStandardLayout.reportStandardLayoutId == -1 && this.initialLoad) {
                    this.editLayoutProperites();
                  }
                  this.setToFilterPage().then((res2) => {
                  })
                }
              })

            }, 1000);
            this.firstLoad = false;
            this.lastRendered = new Date();
          } else {

            clearTimeout(this.overallTimeout);

            console.log("Force Next Page Guard Started...");
            this.overallTimeout = setTimeout(() => {
              var currentPage = this.activeReportPages.indexOf(this.currentPage);
              console.log("Forcing Next Page...");
              console.log('##PAGE##' + (currentPage + 1).toString() + '##' + totalPages.toString());
              setTimeout(() => {
                this.moveNextPage();
              }, 15000);
            }, this.forceNextPageGuardTime);

            if (this.userState == null) {
              console.log("Event: ", event);
              var currentPage = this.activeReportPages.indexOf(this.currentPage);
              var totalPages = this.activeReportPages.length;

              clearTimeout(this.currentTimeout);
              clearTimeout(this.pagingTimeout);

              this.currentTimeout = setTimeout(() => {
                if (currentPage < (totalPages - 1)) {
                  if (currentPage == 0) {
                    console.log('##FIRST PAGE##' + (currentPage + 1).toString() + '##' + totalPages.toString());
                  } else {
                    console.log('##PAGE##' + (currentPage + 1).toString() + '##' + totalPages.toString());
                  }

                  this.pagingTimeout = setTimeout(() => {
                    this.moveNextPage();
                  }, this.pagingTimeoutTime);
                } else {
                  console.log('##LAST PAGE##' + (currentPage + 1).toString() + '##' + totalPages.toString());
                }
              }, this.currentTimeoutTime);
            }
          }
        });

        this.embeddedReport.on("visualRendered", (_) => {
          console.log('--- VISUAL RENDERED ---');
        });
      })
    });
  }

  public loadEmbeddedState(showButtons: boolean, reportEmbedDetails: EmbedReportDetails | undefined, reportEmbeddedExport: US_ReportEmbededExport, preFilters: PreFilter[], reportSource: ReportSource, reportEmbeddedType: ReportEmbeddedType, initialLoad: boolean, clearBookmark: boolean, userState?: UserState, paramFilter?: ParamFilter) {
    this.initialLoad = initialLoad;
    this.standardType = false;
    this.embedType = true;

    this.embedDetails = reportEmbedDetails;

    // this.loadingReport = true;
    this.showButtons = showButtons;
    this.reportEmbeddedExport = reportEmbeddedExport;
    this.preFilters = preFilters;
    this.reportSource = reportSource;
    this.reportEmbeddedType = reportEmbeddedType;
    this.userState = userState;
    this.activeReportPages = this.loadReportPages(reportEmbeddedType.reportPages);
    this.currentPage = this.activeReportPages[0];

    this.firstLoad = true;

    if (this.embeddedReport) {
      this.embeddedReport.off("rendered");
    }

    var targetParamFilter: ParamFilter | undefined  = paramFilter;

    this.powerbiService.powerBIGetPowerBISettingsForReportEmbeddedType(this.reportEmbeddedType.reportEmbeddedTypeId).subscribe((powerBiSettingsResults) => {
      this.getReportConfig(powerBiSettingsResults, paramFilter).then(currentConfig => {
        this.currentConfig = currentConfig;
        this.embeddedReport = this.powerBiClientService.embed(
          this.pbiContainer.nativeElement,
          this.currentConfig
        ) as PbiReport;

        this.app.pushLoading("Loading Widget");

        //this.embeddedReport.on("loaded", (_) => {
        //  this.app.popLoading();
        //});

        this.embeddedReport.on("rendered", (_) => {
          if (this.firstLoad) {
            window.setTimeout(() => {
              if (paramFilter) {
                if (this.userState == null) {
                  this.setToInitialPage().then((res2) => {
                    this.app.popLoading();
                    this.loadingReport = false;
                  })
                } else {
                  this.setToFilterPage().then((res2) => {
                    this.app.popLoading();
                    this.loadingReport = false;
                    if (this.reportEmbeddedExport.reportEmbeddedExportId == -1 && this.initialLoad) {
                      this.editLayoutProperites();
                    }
                  })
                }
              } else {
                if (!clearBookmark) {
                  this.injectFilterData(this.reportEmbeddedExport.filterData).then((res) => {
                    if (this.userState == null) {
                      this.setToInitialPage().then((res2) => {
                        this.app.popLoading();
                        this.loadingReport = false;
                      })
                    } else {
                      this.setToFilterPage().then((res2) => {
                        this.app.popLoading();
                        this.loadingReport = false;
                        if (this.reportEmbeddedExport.reportEmbeddedExportId == -1 && this.initialLoad) {
                          this.editLayoutProperites();
                        }
                      })
                    }
                  });
                } else {
                  if (this.userState == null) {
                    this.setToInitialPage().then((res2) => {
                      this.app.popLoading();
                      this.loadingReport = false;
                    })
                  } else {
                    this.setToFilterPage().then((res2) => {
                      this.app.popLoading();
                      this.loadingReport = false;
                      if (this.reportEmbeddedExport.reportEmbeddedExportId == -1 && this.initialLoad) {
                        this.editLayoutProperites();
                      }
                    })
                  }
                }
              }
            }, 1000);
            this.firstLoad = false;
          }
        });
      })
    });
  }

  setToFilterPage(): Promise<any> {
    return new Promise((resolve, error) => {
      this.embeddedReport.getPages().then((allPages) => {
        this.allPages = allPages;
        if (this.standardType) {
          this.setPage(this.reportStandardType.filterPage).then((res) => {
            resolve('');
          })
        } else if (this.embedType) {
          this.setPage(this.reportEmbeddedType.filterPage).then((res) => {
            resolve('');
          })
        }
      })
    })
  }

  setToInitialPage(): Promise<any> {
    var reportPages = this.activeReportPages;
    return new Promise((resolve, error) => {
      this.embeddedReport.getPages().then((allPages) => {
        this.allPages = allPages;
        if (this.standardType) {
          this.lastReportPage = reportPages[0];
          this.setPage(reportPages[0]).then((res) => {
            resolve('');
          })
        } else if (this.embedType) {
          this.setPage(this.reportEmbeddedExport.reportPage).then((res) => {
            resolve('');
          })
        }
      })
    })
  }

  setPage(displayName: string): Promise<any> {
    return new Promise<any>((resolve, error) => {
      var pageName = this.getPageName(displayName);
      this.embeddedReport.setPage(pageName);
      this.currentPage = displayName;
      resolve('');
    })
  }

  getPageName(displayName: string): string {
    var page = this.allPages.find(x => x.displayName == displayName);
    return page.name;
  }

  readHeaderImage(files: FileList) {
    var srcFile = files.item(0);
    const reader = new FileReader();
    reader.onload = e => this.reportStandardLayout.headerImageUri = reader.result as string;
    reader.readAsDataURL(srcFile);
  }

  readFooterImage(files: FileList) {
    var srcFile = files.item(0);
    const reader = new FileReader();
    reader.onload = e => this.reportStandardLayout.footerImageUri = reader.result as string;
    reader.readAsDataURL(srcFile);
  }

  getLayoutType(): PbiLayoutType | undefined {
    if (this.deviceService.isMobile()) {
      if (this.deviceService.orientation === 'landscape') {
        return PbiLayoutType.MobileLandscape;
      } else if (this.deviceService.orientation === 'portrait') {
        return PbiLayoutType.MobilePortrait;
      }
    }

    return undefined;
  }

  getReportConfig(powerBiSettingsResults: PowerBISettings, paramFilter?: ParamFilter): Promise<any> {
    var preFilterService = this.preFilterService;
    var preFilterId = "-1";
    var generatePreFilterValues = this.generatePreFilterValuesV2;
    var generateParamFilterValues = this.generateParamFilterValues;
    var preFilters = this.preFilters;
    var currentReport = this.reportStandardLayout;
    var currentEmbed = this.reportEmbeddedExport;
    var standardType = this.standardType;
    var embedType = this.embedType;
    var reportSource = this.reportSource;

    if (preFilters.length > 0) {
      preFilterId = preFilters.find(x => x.isDefault).preFilterId.toString();
    }

    if (standardType && currentReport.preFilterId && currentReport.preFilterId != -1) {
      preFilterId = currentReport.preFilterId.toString();
    }

    if (embedType && currentEmbed.preFilterId && currentEmbed.preFilterId != -1) {
      preFilterId = currentEmbed.preFilterId.toString();
    }

    var layoutType = this.getLayoutType();

    var basicPreFilter = {
      type: "report",
      id: powerBiSettingsResults.reportId,
      embedUrl: powerBiSettingsResults.embedUrl,
      accessToken: powerBiSettingsResults.accessToken,
      settings: {
        layoutType,
        visualRenderedEvents: true,
        navContentPaneEnabled: false,
        bookmarksPaneEnabled: false,
        filterPaneEnabled: false,
        bars: {
          actionBar: {
            visible: false,
          },
        },
      },
    };

    return new Promise<any>((resolve, error) => {
      this.preFilterValues = undefined;

      if (paramFilter) {
        generateParamFilterValues(paramFilter).then((config) => {
          var finalConfig = {
            type: "report",
            id: powerBiSettingsResults.reportId,
            embedUrl: powerBiSettingsResults.embedUrl,
            accessToken: powerBiSettingsResults.accessToken,
            filters: config,
            viewMode: PbiModels.ViewMode.View,
            settings: {
              layoutType,
              navContentPaneEnabled: false,
              bookmarksPaneEnabled: false,
              filterPaneEnabled: false,
              background: 0,
              bars: {
                actionBar: {
                  visible: false,
                },
              },
            },
          };

          resolve(finalConfig);
        });
      } else if (preFilterId === "-1") {
        resolve(basicPreFilter);
      } else {
        /*this.regionStateValues = preFilterValuesService.getRegionValues();
        this.industryValues = preFilterValuesService.getIndustryValues();
        this.occupationValues = preFilterValuesService.getOccupationValues();

        preFilterService.preFilterGetPreFilterById(+preFilterId).subscribe(result => {
          generatePreFilterValues(result, reportSource, preFilterService).then((config) => {
            this.preFilterValues = config;
            var finalConfig = {
              type: "report",
              id: powerBiSettingsResults.reportId,
              embedUrl: powerBiSettingsResults.embedUrl,
              accessToken: powerBiSettingsResults.accessToken,
              filters: this.preFilterValues,
              viewMode: PbiModels.ViewMode.View,
              settings: {
                layoutType,
                navContentPaneEnabled: false,
                bookmarksPaneEnabled: false,
                filterPaneEnabled: false,
                background: 0,
                bars: {
                  actionBar: {
                    visible: false,
                  },
                },
              },
            };

            if (standardType && this.reportStandardLayout.backgroundColor && this.reportStandardLayout.backgroundColor != '') {
              finalConfig.settings.background = 1; // Transparent
            };

            resolve(finalConfig);
          });
          },
          error => {
            resolve(basicPreFilter);
          });*/
      }
    });
  }

  async applyPreFilter(preFilterId: number): Promise<boolean> {
    var preFilterService = this.preFilterService;
    var reportSource = this.reportSource;
    var generatePreFilterValues = this.generatePreFilterValuesV2;
    var embeddedReport = this.embeddedReport;

    this.preFilterService.preFilterGetPreFilterById(preFilterId).subscribe(result => {
      generatePreFilterValues(result, reportSource, preFilterService).then(filterData => {
        embeddedReport.setFilters(filterData);
      });
    });

    return false;
  }

  async generateParamFilterValues(paramFilter: ParamFilter): Promise<any[]> {

    var resultFilters = [];

    if (paramFilter.zipCode) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'regions',
          column: 'zip_code'
        },
        values: [paramFilter.zipCode],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.cbsaCode) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'regions',
          column: 'cbsa_code'
        },
        values: [paramFilter.cbsaCode],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.onetCode) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'occupations',
          column: 'onet_code'
        },
        values: [paramFilter.onetCode],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.jobTitle) {
      resultFilters.push({
        $schema: "https://powerbi.com/product/schema#advanced",
        target: {
          table: "clean_titles",
          column: "title"
        },
        logicalOperator: "And",
        conditions: [
          {
            operator: "Contains",
            value: paramFilter.jobTitle
          }
        ],
        filterType: 0
      });
    }

    if (paramFilter.indeedCompany) {
      resultFilters.push({
        $schema: "https://powerbi.com/product/schema#advanced",
        target: {
          table: "companies",
          column: "indeed_company"
        },
        logicalOperator: "And",
        conditions: [
          {
            operator: "Contains",
            value: paramFilter.indeedCompany
          }
        ],
        filterType: 0
      });
    }

    if (paramFilter.orgId) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'companies',
          column: 'organization_id'
        },
        values: [paramFilter.orgId],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.companyKey) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'companies',
          column: 'key'
        },
        values: [paramFilter.companyKey],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.naicsCode) {
      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'companies',
          column: 'primary_naics'
        },
        values: [paramFilter.naicsCode],
        requireSingleSelection: true,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });
    }

    if (paramFilter.dateRangeStart && !paramFilter.dateRangeEnd) {

      var startDate = new Date(paramFilter.dateRangeStart);

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "date_calendar",
          column: "date"
        },
        logicalOperator: 'AND',
        conditions: [
          {
            operator: 'GreaterThanOrEqual',
            value: startDate.toISOString()
          }
        ],
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    } else if (!paramFilter.dateRangeStart && paramFilter.dateRangeEnd) {

      var endDate = new Date(paramFilter.dateRangeEnd);

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "date_calendar",
          column: "date"
        },
        logicalOperator: 'AND',
        conditions: [
          {
            operator: 'LessThanOrEqual',
            value: endDate.toISOString()
          }
        ],
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    } else if (paramFilter.dateRangeStart && paramFilter.dateRangeEnd) {

      var startDate = new Date(paramFilter.dateRangeStart);
      var endDate = new Date(paramFilter.dateRangeEnd);

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "date_calendar",
          column: "date"
        },
        logicalOperator: 'AND',
        conditions: [
          {
            operator: 'GreaterThanOrEqual',
            value: startDate.toISOString()
          },
          {
            operator: 'LessThanOrEqual',
            value: endDate.toISOString()
          }
        ],
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    return resultFilters;
  }

  async generatePreFilterValuesV2(preFilter: US_PreFilter, reportSource: ReportSource, preFilterService: PreFilterService): Promise<any[]> {
    var resultFilters = [];

    /*var preFilterExpandedDetails = await preFilterService.preFilterGetPreFilterExpandedDetails(preFilter.preFilterId).toPromise();

    var titles: string[] = preFilterExpandedDetails.titles;
    var fuzzyTitles: string[] = preFilterExpandedDetails.fuzzyTitles;
    var companies: string[] = preFilterExpandedDetails.companies;
    var fuzzyCompanies: string[] = preFilterExpandedDetails.fuzzyCompanies;
    var stateCbsas: string[] = preFilterExpandedDetails.metroAreaIds;
    var industryIndustryIds: string[] = preFilterExpandedDetails.nationalIndustryIds;
    var occupationSocCodes: string[] = preFilterExpandedDetails.occupationSocCodes;

    if (reportSource.preFilterTitleAvailable && (titles.length > 0 || fuzzyTitles.length > 0)) {
      // 'Clean Job Titles[Clean Title]

      var logicalOperator = "Or";

      if (preFilter.titlesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = titles.map((x) => ({ operator: "Contains", value: x }));

      fuzzyTitles.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Job Titles",
          column: "Job Title"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (reportSource.preFilterCompanyAvailable && (companies.length > 0 || fuzzyCompanies.length > 0)) {
      // 'Company Profiles'[Company Name]

      var logicalOperator = "Or";

      if (preFilter.companiesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = companies.map((x) => ({ operator: "Contains", value: x }));

      fuzzyCompanies.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Companies",
          column: "Company"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (reportSource.preFilterOccupationAvailable && occupationSocCodes.length > 0) {
      // 'Occupations (SOC)'[O*NET SOC Code]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Occupations',
          column: 'ONET Code'
        },
        values: occupationSocCodes,
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (reportSource.preFilterIndustryAvailable && industryIndustryIds.length > 0) {
      // 'Industries (NAICS)'[National Industry ID]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Industries (NAICS)',
          column: 'Industry (NAICS)'
        },
        values: industryIndustryIds,
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (reportSource.preFilterRegionAvailable && stateCbsas.length > 0) {
      // 'Regions'[Metro Area ID (CBSA)]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Regions',
          column: 'CBSA Code'
        },
        values: stateCbsas.filter(x => x != '00000'),
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }*/

    return resultFilters;
  }

  async injectFilterData(filterData: string): Promise<any> {
    try {
      const filterDetails = JSON.parse(filterData);
      await this.embeddedReport.bookmarksManager.applyState(filterDetails.state);

      /*if (filterDetails) {
        if (filterDetails.filters && filterDetails.filters.length > 0) {
          //this.embeddedReport.setFilters(filterDetails.filters);
        }

        const allPages = await this.embeddedReport.getPages();

        if (allPages) {
          for (let i = 0; i < filterDetails.pages.length; i++) {
            const targetPage = allPages.find(x => x.name === filterDetails.pages[i].name);
            if (targetPage) {
              if (filterDetails.pages[i].filters.length > 0) {
                //targetPage.setFilters(filterDetails.pages[i].filters);
              }

              try {
                const allVisuals = await targetPage.getVisuals();
                for (let e = 0; e < filterDetails.pages[i].visuals.length; e++) {
                  if (filterDetails.pages[i].visuals[e].filters || filterDetails.pages[i].visuals[e].slicer) {
                    const targetVisual = allVisuals.find(x => x.name === filterDetails.pages[i].visuals[e].name);
                    if (targetVisual) {
                      if (filterDetails.pages[i].visuals[e].filters) {
                        //targetVisual.setFilters(filterDetails.pages[i].visuals[e].filters);
                      }

                      if (filterDetails.pages[i].visuals[e].slicer) {
                        targetVisual.setSlicerState(filterDetails.pages[i].visuals[e].slicer);
                      }
                    }
                  }
                }
              } catch { }
            }
          }
        }
      }*/
    }
    catch { }

    return '';

    /*return new Promise<any>((resolve, error) => {


      if (filterData && filterData.length > 0) {
        var segments = filterData.split("<-->");
        var mainFilterJSON = '';
        var pageFiltersJSON = '';

        if (segments.length > 0) {
          mainFilterJSON = segments[0];
        }

        if (segments.length > 1) {
          pageFiltersJSON = segments[1];
        }

        if (mainFilterJSON && mainFilterJSON !== '' && mainFilterJSON != '-1') {
          const reportFilters: PbiModels.IFilter[] = JSON.parse(mainFilterJSON);
          this.embeddedReport.setFilters(reportFilters);
        }

        if (pageFiltersJSON && pageFiltersJSON != '' && pageFiltersJSON != '-1') {
          const pageFilters: string[] = JSON.parse(pageFiltersJSON);
          this.embeddedReport.getPages().then((allPages) => {
            for (let page = 0; page < allPages.length; page++) {
              if (page < pageFilters.length) {
                const filters: PbiModels.IFilter[] = JSON.parse(pageFilters[page]);
                if (filters.length > 0) {
                  allPages[page].setFilters(filters);
                }
              }
            }
            resolve('');
          });
        } else {
          resolve('');
        }
      } else {
        resolve('');
      }
    })*/
  }

  async getReportFilters(): Promise<any> {
    return await this.embeddedReport.bookmarksManager.capture();
    //return await this.embeddedReport.getFilters();
  }

  async getPageFilters(): Promise<any> {
    const pageFilters: any[] = [];
    const allPages = await this.embeddedReport.getPages();
    if (allPages) {
      for (let i = 0; i < allPages.length; i++) {
        try {
          try {
            const filters = await allPages[i].getFilters();
            pageFilters.push(
              {
                name: allPages[i].name,
                filters: [],
                visuals: []
              });
          } catch { }
          const allVisuals = await allPages[i].getVisuals();
          if (allVisuals) {
            for (let e = 0; e < allVisuals.length; e++) {
              let allFilters: any = undefined;
              let slicerState: any = undefined;

              try {
                allFilters = await allVisuals[e].getFilters();
              } catch { }

              try {
                slicerState = await allVisuals[e].getSlicerState();
              } catch { }

              if ((allFilters && allFilters.length > 0) || slicerState) {
                pageFilters[pageFilters.length - 1].visuals.push(
                  {
                    name: allVisuals[e].name,
                    title: allVisuals[e].title,
                    filters: [],
                    slicer: slicerState
                  });
              }

            }
          }
        }
        catch { }
      }
    }

    return pageFilters;
  }

  async getFilterData(): Promise<string> {

    const mainFilter = await this.getReportFilters();
    const pageFilter = await this.getPageFilters();
    const finalJSON = JSON.stringify(mainFilter);

    return finalJSON;
  }

  save(): boolean {
    this.saveClicked.emit();
    return false;
  }

  public closeLinkClicked(): boolean {

    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Cancel Changes?",
      "This will discard any changes made to this layout, are you sure?"
    ).subscribe((confirmResult) => {
      if (confirmResult.ResultType === DialogResultType.Ok) {
        this.closeClicked.next();
      }
    });

    return false;
  }

  public editLayoutProperites(): boolean {
    if (this.standardType) {
      const editParams: ReportStandardLayoutPropsDialogData = {
        dialogTitle: "Edit Report Layout Properties",
        reportStandardLayoutId: this.reportStandardLayout.reportStandardLayoutId,
        preFilterId: this.reportStandardLayout.preFilterId,
        subscriptionId: this.reportStandardLayout.subscriptionId,
        name: this.reportStandardLayout.name,
        backgroundColor: this.reportStandardLayout.backgroundColor,
        orderedPages: this.reportStandardLayout.orderedPages,
        headerFile: this.headerFile,
        footerFile: this.footerFile,
        headerImageUri: this.headerImageSrc,
        footerImageUri: this.footerImageSrc,
        clearHeader: false,
        clearFooter: false,

        reportStandardType: this.reportStandardType,
        preFilters: this.preFilters
      }

      const dialogRef = this.dialog.open(ReportStandardLayoutPropsDialogComponent, {
        disableClose: true,
        width: "500px",
        data: editParams
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
          this.reportStandardLayout.preFilterId = result.ResultData.preFilterId;
          this.reportStandardLayout.subscriptionId = result.ResultData.subscriptionId;
          this.reportStandardLayout.name = result.ResultData.name;
          this.reportStandardLayout.backgroundColor = result.ResultData.backgroundColor;
          this.reportStandardLayout.orderedPages = result.ResultData.orderedPages;

          this.loadReportState(this.showButtons, this.reportStandardLayout, this.preFilters, this.reportSource, this.reportStandardType, false, this.userState);

          this.headerImageSrc = result.ResultData.headerImageUri;
          this.footerImageSrc = result.ResultData.footerImageUri;
          this.headerFile = result.ResultData.headerFile;
          this.footerFile = result.ResultData.footerFile;
          this.clearHeader = result.ResultData.clearHeader;
          this.clearFooter = result.ResultData.clearFooter;
        } else {
          if (this.initialLoad) {
            this.closeClicked.next();
          }
        }
      })
    } else if (this.embedType) {
      const editParams: ReportEmbeddedExportPropsDialogData = {
        dialogTitle: "Edit Widget Properties",
        reportEmbeddedExportId: this.reportEmbeddedExport.reportEmbeddedExportId,
        preFilterId: this.reportEmbeddedExport.preFilterId,
        subscriptionId: this.reportEmbeddedExport.subscriptionId,
        name: this.reportEmbeddedExport.name,
        reportPage: this.reportEmbeddedExport.reportPage,
        disabled: this.reportEmbeddedExport.disabled,

        reportEmbeddedType: this.reportEmbeddedType,
        preFilters: this.preFilters
      }

      const dialogRef = this.dialog.open(ReportEmbeddedExportPropsDialogComponent, {
        disableClose: true,
        width: "500px",
        data: editParams
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
          this.reportEmbeddedExport.preFilterId = result.ResultData.preFilterId;
          this.reportEmbeddedExport.disabled = result.ResultData.disabled;
          this.reportEmbeddedExport.name = result.ResultData.name;
          this.reportEmbeddedExport.reportPage = result.ResultData.reportPage;
          this.reportEmbeddedExport.subscriptionId = result.ResultData.subscriptionId;

          this.loadEmbeddedState(true, undefined, this.reportEmbeddedExport, this.preFilters, this.reportSource, this.reportEmbeddedType, false, false, this.userState);
        } else {
          if (this.initialLoad) {
            this.closeClicked.next();
          }
        }
      });
    }

    return false;
  }

  isFirstPage(): boolean {
    if (this.standardType) {
      if (this.currentPage == this.reportStandardType.filterPage) {
        return true;
      }
    } else if (this.embedType) {
      if (this.currentPage == this.reportEmbeddedType.filterPage) {
        return true;
      }
    }

    return false;
  }

  isLastPage(): boolean {
    if (this.standardType) {
      if (this.currentPage == this.activeReportPages[this.activeReportPages.length - 1]) {
        return true;
      }
    } else if (this.embedType) {
      if (this.currentPage == this.reportEmbeddedExport.reportPage) {
        return true;
      }
    }

    return false;
  }

  isValidNextPage(): boolean {
    var currentIndex = this.activeReportPages.indexOf(this.currentPage);
    var targetPage = this.activeReportPages[currentIndex + 1];
    var page = this.allPages.find(x => x.displayName == targetPage);
    if (page) {
      return true;
    }
    return false;
  }

  moveNextPage(): boolean {
    if (this.standardType) {
      if (this.currentPage == this.reportStandardType.filterPage) {
        this.setPage(this.activeReportPages[0]).then((_) => { });
      } else {
        var currentIndex = this.activeReportPages.indexOf(this.currentPage);
        this.setPage(this.activeReportPages[currentIndex + 1]).then((_) => { });
      }
    } else if (this.embedType) {
      if (this.currentPage == this.reportEmbeddedType.filterPage) {
        this.setPage(this.reportEmbeddedExport.reportPage).then((_) => { });
      }
    }

    return false;
  }

  movePrevPage(): boolean {
    if (this.standardType) {
      var currentIndex = this.activeReportPages.indexOf(this.currentPage);
      if (currentIndex == 0) {
        this.setPage(this.reportStandardType.filterPage);
      } else {
        this.setPage(this.activeReportPages[currentIndex - 1]).then((_) => { });
      }
    } else if (this.embedType) {
      if (this.currentPage == this.reportEmbeddedExport.reportPage) {
        this.setPage(this.reportEmbeddedType.filterPage).then((_) => { });
      }
    }

    return false;
  }

  public getLayoutResults(): Promise<ReportLayoutResult> {
    var result: ReportLayoutResult = {
      reportStandardLayoutId: this.reportStandardLayout.reportStandardLayoutId,
      reportStandardTypeId: this.reportStandardType.reportStandardTypeId,
      subscriptionId: this.reportStandardLayout.subscriptionId,
      preFilterId: this.reportStandardLayout.preFilterId,
      name: this.reportStandardLayout.name,
      backgroundColor: this.reportStandardLayout.backgroundColor,
      orderedPages: this.reportStandardLayout.orderedPages,
      headerFile: this.headerFile,
      footerFile: this.footerFile,
      filterData: "-1<-->-1",
      clearHeader: this.clearHeader,
      clearFooter: this.clearFooter
    };

    return new Promise<ReportLayoutResult>((resolve, _) => {
      this.getFilterData().then((filterData) => {
        result.filterData = filterData;

        resolve(result);
      });
    });
  }

  public getEmbeddedResults(): Promise<ReportEmbeddedResult> {
    var result: ReportEmbeddedResult = {
      reportEmbeddedExportId: this.reportEmbeddedExport.reportEmbeddedExportId,
      reportEmbeddedTypeId: this.reportEmbeddedType.reportEmbeddedTypeId,
      name: this.reportEmbeddedExport.name,
      subscriptionId: this.reportEmbeddedExport.subscriptionId,
      preFilterId: this.reportEmbeddedExport.preFilterId,
      filterData: "-1<-->-1",
      reportPage: this.reportEmbeddedExport.reportPage,
      disabled: this.reportEmbeddedExport.disabled
    };

    return new Promise<ReportEmbeddedResult>((resolve, _) => {
      this.getFilterData().then((filterData) => {
        result.filterData = filterData;

        resolve(result);
      })
    });
  }

  printOnDemand() {
    PrintOnDemandDialogComponent.showDialog(this.dialog, 0, this.embedDetails.poDPages, []).subscribe(printResults => {

      if (printResults.ResultType === DialogResultType.Ok) {
        this.embeddedReport.getPages().then(pages => {

          // Find the pages
          const targetPages: string[] = [];
          for (let i = 0; i < printResults.ResultData.selectedPages.length; i++) {
            const page: string = (printResults.ResultData.selectedPages[i]).toLowerCase().trim();
            const pageIndex = pages.findIndex(x => x.name.toLowerCase().trim() === page || x.displayName.toLowerCase().trim() === page);
            if (pageIndex >= 0) {
              targetPages.push(pages[pageIndex].name);
            }
          }

          this.embeddedReport.bookmarksManager.capture({
            allPages: true,
            personalizeVisuals: true
          }).then(bookmarkData => {
            const statusData: PrintOnDemandData = {
              fileType: printResults.ResulData.fileType,
              pages: targetPages,
              embeddedTypeId: this.embedDetails.reportEmbeddedType.reportEmbeddedTypeId,
              bookmarkJson: bookmarkData.state
            };

            this.snackBar.openFromComponent(PodStatusSnackbarComponent, {
              data: statusData
            });
          });
        });
      }
    });

    return false;
  }
}

export class ReportLayoutResult {
  reportStandardLayoutId: number;
  reportStandardTypeId: number;
  subscriptionId: number;
  preFilterId?: number;
  name?: string;
  backgroundColor?: string;
  filterData?: string;
  orderedPages?: string;
  headerFile: File;
  footerFile: File;
  clearHeader: boolean;
  clearFooter: boolean;
}

export class ReportEmbeddedResult {
  reportEmbeddedExportId: number;
  reportEmbeddedTypeId: number;
  name?: string;
  subscriptionId?: number;
  preFilterId?: number;
  filterData?: string;
  reportPage?: string;
  disabled: boolean;
}

export interface ParamFilter {
  zipCode: string | undefined;
  cbsaCode: string | undefined;
  onetCode: string | undefined;
  jobTitle: string | undefined;
  indeedCompany: string | undefined;
  companyKey: string | undefined;
  orgId: string | undefined;
  naicsCode: string | undefined;
  dateRangeStart: string | undefined;
  dateRangeEnd: string | undefined;

}
